module.exports = __webpack_public_path__ + "img/coinbankC05.9be4f664.jpg";